import Dialog from 'quasar/src/plugins/Dialog.js';import Notify from 'quasar/src/plugins/Notify.js';import Quasar from 'quasar/src/vue-plugin.js';

import '@/styles/shared/quasar.scss'
import '@/styles/shared/main.scss'
import 'quasar/dist/quasar.ie.polyfills'
import '@quasar/extras/material-icons/material-icons.css'

import '@niknevis/fontawesome-pro/css/fontawesome.css'
import '@niknevis/fontawesome-pro/css/duotone.css'
import '@niknevis/fontawesome-pro/css/light.css'

import langFa from 'quasar/lang/fa'
import { BootFileParams } from '@niknevis/vue-modules/types'

export default function({ Vue }: BootFileParams) {
  Vue.use(Quasar, {
    plugins: {
      Notify,
      Dialog
    },
    config: {
      notify: {}
    },
    lang: langFa
  })
}
